import {
  CreateServiceDto,
  ListServiceParamDto,
  UpdateServiceDto,
} from "../entities/dto/service.dto";
import { Service } from "../entities/interfaces/service";
import Api, { ApiResponse } from "../utils/axios";

export const list = async (
  params: ListServiceParamDto
): Promise<ApiResponse<Service[]>> => {
  return await Api.get(`/services?${new URLSearchParams(params)}`);
};

export const Get = async (id: string): Promise<ApiResponse<Service>> => {
  return await Api.get(`/services/${id}`);
};

export const create = async (
  createServiceDto: CreateServiceDto
): Promise<ApiResponse<Service>> => {
  return await Api.post("/services", createServiceDto);
};

export const update = async (
  id: string,
  updateServiceDto: UpdateServiceDto
): Promise<ApiResponse<Service>> => {
  return await Api.patch(`/services/${id}`, updateServiceDto);
};

export const deleteStoreService = async (
  serviceId: string,
  storeServiceId: string
): Promise<ApiResponse<Service>> => {
  return await Api.delete(
    `/services/${serviceId}/storeService/${storeServiceId}`
  );
};

export const exportServices = async (): Promise<any> => {
  return await Api.get(`/services/export`, {
    responseType: "blob",
    headers: {
      Accept: "text/csv",
    },
  });
};
const ServiceService = {
  list,
  update,
  create,
  Get,
  deleteStoreService,
  exportServices,
};
export default ServiceService;
